import axios from "axios";
import { store } from "../../store";

export async function createContactAction() {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const { email, phoneNumber } = store.getState().contact;

  const params = {
    email,
    phoneNumber,
  };

  return await axios
    .post(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/contacts`, params, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
}
